// extracted by mini-css-extract-plugin
export default {"contentContainer":"ShopContent_contentContainer__a67kf","productCardsContainer":"ShopContent_productCardsContainer__hxinp"};